/**
 * Enum loại hóa đơn
 * PQDat 02.08.2022
 */
export default {
  /**
   * Hóa đơn thay thế
   */
  Replacement: 2,

  /**
   * Hóa đơn điều chỉnh
   * vqphong - 06/10/2022
   */
  AdjustmentSaleInvoice: 3,
};
